import React, { useEffect } from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import "./whatsappApi.css";

import AOS from "aos";

export default function WhatsappApi() {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Navbar />
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1400 222">
        <path
          fill="#D30032"
          fill-opacity="1"
          d="M0,32L30,64C60,96,120,160,180,165.3C240,171,300,117,360,122.7C420,128,480,192,540,213.3C600,235,660,213,720,181.3C780,149,840,107,900,96C960,85,1020,107,1080,112C1140,117,1200,107,1260,96C1320,85,1380,75,1410,69.3L1440,64L1440,0L1410,0C1380,0,1320,0,1260,0C1200,0,1140,0,1080,0C1020,0,960,0,900,0C840,0,780,0,720,0C660,0,600,0,540,0C480,0,420,0,360,0C300,0,240,0,180,0C120,0,60,0,30,0L0,0Z"
        ></path>
      </svg>
      <div className="mainContentNusaCRM pb-3">
        <div className="container">
          <h1
            className="text-center fw-bold text-danger py-4"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            Layanan Whatsapp Business API
          </h1>
          <div
            className="d-flex justify-content-between contentNusaCrmOne"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="wrapperNusaCrm text-center px-lg-5 mx-lg-5 px-md-5">
              <div
                id="carouselExampleCaptions"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-indicators">
                  <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="0"
                    className="active"
                    aria-current="true"
                    aria-label="Slide 1"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="1"
                    aria-label="Slide 2"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="2"
                    aria-label="Slide 3"
                  ></button>
                </div>
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img
                      src={require("../../assets/wa-blash-1.png")}
                      className=""
                      alt="..."
                      width={230}
                    />
                    <div className="carousel-caption d-none d-md-block"></div>
                  </div>
                  <div className="carousel-item">
                    <img
                      src={require("../../assets/wa-blash-3.png")}
                      className=""
                      alt="..."
                      width={230}
                    />
                    <div className="carousel-caption d-none d-md-block"></div>
                  </div>
                  <div className="carousel-item">
                    <img
                      src={require("../../assets/wa-blash-1.png")}
                      className=""
                      alt="..."
                      width={230}
                    />
                    <div className="carousel-caption d-none d-md-block"></div>
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExampleCaptions"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="text-danger fw-bold"></span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExampleCaptions"
                  data-bs-slide="next"
                >
                  <span className="text-danger fw-bold"></span>
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                </button>
              </div>
            </div>
            <div className="descriptionNusaCrm px-lg-5 px-md-5 py-md-3 fs-5">
              <p>
                Kami semakin berekspansi dalam bidang teknologi, kami tahu bahwa
                komunikasi adalah hal utama untuk pertumbuhan bisnis yang
                optimal. Di tahun 2022 kami berhasil meluncurkan NusaCRM.
              </p>
              <p>
                NusaCRM adalah layanan dashboard yang memudahkan perusahaan
                mengirim push notification HSM (Highly Structured Message)
                melalui manual chat upload. Diharapkan perusahaan dapat
                menjangkau lebih banyak pelanggan dalam berkomunikasi dan
                berinteraksi.
              </p>
            </div>
          </div>

          <h1 className="text-center py-4 fw-bold" data-aos="zoom-in-left">
            Fitur <br />
            <span className="fst-italic">Layanan WhatsApp Business </span>
          </h1>
          <div className="d-flex justify-content-around contentNusaCrmTwo">
            <div className="text-center" data-aos="flip-down">
              <img
                src={require("../../assets/whatsapp-blash.png")}
                alt=""
                className="img-fluid"
              />
            </div>

            <div>
              <ul className="listNusaCrm" data-aos="zoom-in-left">
                <li>Push Notification Message</li>
                <li>Push Notification Media</li>
                <li>Push Notification HSM Template dengan Button</li>
                <li>Push Button HMS (Call-To-Action)</li>
                <li>Push Button HSM (Quick Reply)</li>
                <li>Interaktif dengan Live Agent (Helpdesk)</li>
                <li>Chatbot Artificial Intelligence</li>
              </ul>
            </div>
          </div>
          <div className="container d-flex justify-content-around py-4">
            <div data-aos="flip-down">
              <h1 className="text-center pb-4 fs-3">Official</h1>
              <div className="officialDist">
                <img
                  src={require("../../assets/wa-blash-1.png")}
                  alt=""
                  width={180}
                />
              </div>
              <div>
                <h4 className="pt-3">Keunggulan :</h4>
                <ul className="listKeunggulan">
                  <li>Memiliki centang hijau resmi.</li>
                  <li>
                    Kirim pesan masal dengan maksimal tiering <br />
                    berdasarkan ketentuan facebook.
                  </li>
                  <li>Memiliki centang hijau resmi.</li>
                  <li>
                    Terdapat masking name meski kontak <br /> tujuan tidak
                    memiliki nomor bussines Anda.
                  </li>
                  <li>Aman tanpa takut terblokir.</li>
                  <li>Lebih mudah menjangkau customer.</li>
                  <li>
                    Memiliki fitur blasting, chat bot, live chat, campaign.
                  </li>
                </ul>
              </div>
            </div>

            <div className="border"></div>

            <div data-aos="flip-down">
              <h1 className="text-center pb-4 fs-3">Unofficial</h1>
              <div className="officialDist">
                <img
                  src={require("../../assets/wa-blash-3.png")}
                  alt=""
                  width={180}
                />
              </div>
              <div>
                <h4 className="pt-3">Keunggulan :</h4>
                <ul className="listKeunggulan">
                  <li>Kirim pesan masal tanpa ketentuan tiering.</li>
                  <li>Dapat menjangkau customer secara luas.</li>
                  <li>Lebih terjangkau.</li>
                  <li>Hanya terlihat long number tanpa nama.</li>
                  <li>Aman tanpa takut terblokir.</li>
                  <li>
                    Memiliki fitur blasting, chat bot, live chat, campaign.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
